import * as Yup from 'yup'

export interface DocumentFormValues {
  fileName: string
  newPath: string
  tags: string
  file: File | null
}

export const documentValidationSchema = Yup.object({
  file: Yup.mixed().nullable().required('A file is required'),
  newPath: Yup.string()
    .required('File path is required')
    .matches(
      /^[a-zA-Z0-9/_\-\s]*$/,
      'File path can only contain letters, numbers, underscores, hyphens, spaces, and slashes.'
    )
    .max(255, 'File path must not exceed 255 characters'),
  fileName: Yup.string().required('File name is required'),
  tags: Yup.string(),
})

export const editorModeList: string[] = [
  'Editor',
  'Administrator',
  'SuperAdministrator',
  'DHIAdmin',
]

export const deleteModeList: string[] = ['Administrator', 'SuperAdministrator', 'DHIAdmin']

export type DocumentRoot = {
  name: string
  path: string
}

export type Directory = {
  name: string
  fileSize: number
  modifiedDateTime: string
  subDirectories?: Directory[]
  files?: File[]
}

export type File = {
  id: string
  name: string
  fileSize: number
  modifiedDateTime: string
  isOnline?: boolean
  status?: string
}

export enum ApprovalStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Archived = 'archived',
}
